












import { Component, Prop, Vue } from "vue-property-decorator";
import * as def from "@/definitions";

import TextController from "./textController/textController.vue";
import DateTextController from "./dateTextController/dateTextController.vue";
import ImageController from "./imageController/imageController.vue";
import PatternController from "./patternController/patternController.vue";
import LineController from "./lineController/lineController.vue";
import BarcodeController from "./barcodeController/barcodeController.vue";
import QRcodeController from "./qrcodeController/qrcodeController.vue";

@Component({
    components: {
        TextController,
        DateTextController,
        ImageController,
        PatternController,
        LineController,
        BarcodeController,
        QRcodeController
    }
})

//******************************************//
//**************** モバイル用 ****************//
//******************************************//
export default class EditController extends Vue 
{
    // どのコントロールを表示するか
    private get editControllerType()
    {
        var type = "";

        // カレントレイヤー
        var currentLayer = this.getCurrentLayer();

        if(currentLayer != null)
        {
            if(currentLayer.layerType == "plainText" || currentLayer.layerType == "circleText")
            {
                type = "text";
            }
            else if(currentLayer.layerType == "dateText")
            {
                type = "dateText";
            }
            else if(currentLayer.layerType == "rasterImage" || currentLayer.layerType == "vectorImage")
            {
                type = "image";
            }
            else if(currentLayer.layerType == "rectangle" || currentLayer.layerType == "circle" || currentLayer.layerType == "polygon")
            {
                type = "pattern";
            }
            else if(currentLayer.layerType == "line" || currentLayer.layerType == "curve")
            {
                type = "line";
            }
            else if(currentLayer.layerType == "barcode")
            {
                type = "barcode";
            }
            else if(currentLayer.layerType == "qrcode")
            {
                type = "qrcode";
            }
        }

        return type;
    }

    private getCurrentLayer()
    {
        var document = this.$store.getters.document;
        var page = document.pageList[document.currentPageIndex];
        var surface = page.getSurface(document.isReverseSurface);
        var design = surface.getDesign(page.currentDesignPosition);
        return design != null ? design.currentLayer : null;
    }

    private onDoCommand(command: string, parameter: any)
    {
        this.$emit("doCommand", command, parameter);
    }
}
